const DRIVER_MOBILE_USER_KEY = 'driverMobileUser';

const normalizeDriverMobileUser = <T extends Record<string, any>>(user: T): T => {
  if (!user || typeof user !== 'object') return user;

  const normalizedName = user.name || user.fullName || user.full_name || user.username || '';
  const isCorporateSubUser = user.role === 'corporate-external-transport-user' || (Array.isArray(user.roles) && user.roles.includes('corporate-external-transport-user')) || ((user.role === 'corporate-external-transport' || (Array.isArray(user.roles) && user.roles.includes('corporate-external-transport'))) && Boolean(user.externalTransportAccountUserId || user.external_transport_account_user_id));
  return {
    ...user,
    ...(isCorporateSubUser ? {
      originalRole: user.originalRole || user.role,
      role: 'external-driver',
      roles: ['external-driver'],
      roleIds: ['external-driver'],
      role_ids: ['external-driver'],
      driverType: 'external',
    } : {}),
    name: normalizedName,
    fullName: user.fullName || user.full_name || normalizedName,
    full_name: user.full_name || user.fullName || normalizedName,
  } as T;
};

export const hydrateDriverMobileSession = () => {
  const sessionUser = sessionStorage.getItem(DRIVER_MOBILE_USER_KEY);
  if (sessionUser) return;

  const localUser = localStorage.getItem(DRIVER_MOBILE_USER_KEY);
  if (localUser) {
    sessionStorage.setItem(DRIVER_MOBILE_USER_KEY, localUser);
  }
};

export const getStoredDriverMobileUser = <T = any>(): T | null => {
  try {
    const raw = sessionStorage.getItem(DRIVER_MOBILE_USER_KEY) || localStorage.getItem(DRIVER_MOBILE_USER_KEY);
    if (!raw) return null;

    if (!sessionStorage.getItem(DRIVER_MOBILE_USER_KEY)) {
      sessionStorage.setItem(DRIVER_MOBILE_USER_KEY, raw);
    }

    return normalizeDriverMobileUser(JSON.parse(raw) as T);
  } catch {
    return null;
  }
};

export const setStoredDriverMobileUser = (user: unknown) => {
  const value = JSON.stringify(normalizeDriverMobileUser((user || {}) as Record<string, any>));
  sessionStorage.setItem(DRIVER_MOBILE_USER_KEY, value);
  localStorage.setItem(DRIVER_MOBILE_USER_KEY, value);
};

export const clearStoredDriverMobileUser = () => {
  sessionStorage.removeItem(DRIVER_MOBILE_USER_KEY);
  localStorage.removeItem(DRIVER_MOBILE_USER_KEY);
};
